import { render, staticRenderFns } from "./AmeldingListHeader.vue?vue&type=template&id=3b5c4fc8&scoped=true&functional=true&"
import script from "./AmeldingListHeader.vue?vue&type=script&lang=ts&"
export * from "./AmeldingListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingListHeader.vue?vue&type=style&index=0&id=3b5c4fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3b5c4fc8",
  null
  
)

export default component.exports